import { Trans } from '@lingui/react'
import { PictogramIcon } from '@speedlo/ui'
import React from 'react'
import styled from 'styled-components/macro'

import { DeliveryTypeEnum } from '../../../graph/generated'
import { TOrderModel } from '../../../models/OrderModel'
import { RM } from '../../../tools/ramda'
import { OrderMethodButton } from './OrderMethodButton'

interface IProps {
  onChange?(order: TOrderModel): void
}

const StyledOrderMethod = styled.div`
  padding: 0.2rem;

  & button {
    font-size: 1.3rem;
    margin: 0.3rem 1rem 0.3rem 1rem;
    padding: 0.3rem 1.2rem;
    height: 2.7rem;
    line-height: 1rem;
    white-space: nowrap;
  }

  .icon {
    margin-right: 0.8rem;
  }
`

export const OrderMethod: React.FC<IProps> = ({ onChange = RM.identity }) => {
  return (
    <StyledOrderMethod>
      <OrderMethodButton
        orderMethod={DeliveryTypeEnum.Messenger}
        onChange={onChange}
      >
        <PictogramIcon icon="transport" className="icon" size={1.4} inline />
        <Trans>I want to deliver</Trans>
      </OrderMethodButton>
      <OrderMethodButton
        orderMethod={DeliveryTypeEnum.Pickup}
        onChange={onChange}
      >
        <PictogramIcon icon="restaurant" className="icon" size={1.4} inline />
        <Trans>I'll pick up</Trans>
      </OrderMethodButton>
    </StyledOrderMethod>
  )
}
